/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/customerHealthLabel.ts
 * PURPOSE: Labels and styling for composite customer health (distinct from SI lead score)
 * PUBLIC_API: customerHealthLabel, customerHealthPillClass, customerHealthRingClass
 */

import type { CrmHealthTier } from '@shared/lib/frontend/api/crmAccountHealthApi';

export function customerHealthLabel(tier: CrmHealthTier | string): string {
  switch (tier) {
    case 'healthy':
      return 'Healthy';
    case 'watch':
      return 'Watch';
    case 'at_risk':
      return 'At risk';
    default:
      return 'Unknown';
  }
}

export function customerHealthPillClass(tier: CrmHealthTier | string): string {
  switch (tier) {
    case 'healthy':
      return 'bg-emerald-50 text-emerald-800 ring-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-200 dark:ring-emerald-800';
    case 'watch':
      return 'bg-amber-50 text-amber-900 ring-amber-200 dark:bg-amber-950/40 dark:text-amber-100 dark:ring-amber-800';
    case 'at_risk':
      return 'bg-rose-50 text-rose-800 ring-rose-200 dark:bg-rose-950/40 dark:text-rose-100 dark:ring-rose-800';
    default:
      return 'bg-gray-100 text-gray-700 ring-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-600';
  }
}

export function customerHealthRingClass(score: number): string {
  if (score >= 75) return 'text-emerald-500';
  if (score >= 50) return 'text-amber-500';
  return 'text-rose-500';
}

export function customerHealthBarClass(score: number): string {
  if (score >= 75) return 'bg-emerald-500';
  if (score >= 50) return 'bg-amber-500';
  return 'bg-rose-500';
}

export function customerHealthTierFromScore(score: number): CrmHealthTier {
  if (score >= 75) return 'healthy';
  if (score >= 50) return 'watch';
  return 'at_risk';
}
